import { Checkbox } from '@progress/kendo-react-inputs';
import { useBooleanSetting } from './hooks/useSetting';
import { WeatherSettingsChangeSource } from '@fe/weather';

export default function AirmetsSigmetsSettings() {
    const changeSource = WeatherSettingsChangeSource.airmetsSigmets;

    const showTurb = useBooleanSetting('airmetsSigmets', 'showTurb', changeSource);
    const showIcing = useBooleanSetting('airmetsSigmets', 'showIcing', changeSource);
    const showConvective = useBooleanSetting('airmetsSigmets', 'showConvective', changeSource);
    const showVolcanicAsh = useBooleanSetting('airmetsSigmets', 'showVolcanicAsh', changeSource);
    const showBlowingDust = useBooleanSetting('airmetsSigmets', 'showBlowingDust', changeSource);
    const showVisibility = useBooleanSetting('airmetsSigmets', 'showVisibility', changeSource);
    const showSurfaceWind = useBooleanSetting('airmetsSigmets', 'showSurfaceWind', changeSource);
    const showBlowingSand = useBooleanSetting('airmetsSigmets', 'showBlowingSand', changeSource);
    const showOzone = useBooleanSetting('airmetsSigmets', 'showOzone', changeSource);
    const showIfr = useBooleanSetting('airmetsSigmets', 'showIfr', changeSource);
    const showMountainObscuration = useBooleanSetting('airmetsSigmets', 'showMountainObscuration', changeSource);
    const showMountainWave = useBooleanSetting('airmetsSigmets', 'showMountainWave', changeSource);
    const showTropicalCyclone = useBooleanSetting('airmetsSigmets', 'showTropicalCyclone', changeSource);
    const showThunderstorm = useBooleanSetting('airmetsSigmets', 'showThunderstorm', changeSource);
    const showLlws = useBooleanSetting('airmetsSigmets', 'showLlws', changeSource);
    const showFreezingLevel = useBooleanSetting('airmetsSigmets', 'showFreezingLevel', changeSource);

    return (
        <div>
            <Checkbox {...showTurb} label="Turbulence" />
            <Checkbox {...showIcing} label="Icing" />
            <Checkbox {...showConvective} label="Convective" />
            <Checkbox {...showVolcanicAsh} label="Volcanic Ash" />
            <Checkbox {...showBlowingDust} label="Blowing dust" />
            <Checkbox {...showVisibility} label="Visibility" />
            <Checkbox {...showSurfaceWind} label="Surface Wind" />
            <Checkbox {...showBlowingSand} label="Blowing Sand" />
            <Checkbox {...showOzone} label="Ozone" />
            <Checkbox {...showIfr} label="IFR (cig/vis)" />
            <Checkbox {...showMountainObscuration} label="Mountain Obscuration" />
            <Checkbox {...showMountainWave} label="Mountain Wave" />
            <Checkbox {...showTropicalCyclone} label="Tropical cyclone" />
            <Checkbox {...showThunderstorm} label="Thunderstorm" />
            <Checkbox {...showLlws} label="Low Level wind shear" />
            <Checkbox {...showFreezingLevel} label="Freezing level" />
        </div>
    );
}
